import React from 'react';
import LottieAnimation from '@/v2/components/behaviours/LottieAnimation';
import Icon from '@/v2/components/atoms/Icon';
import animationData from './LottieScrollMouse.json';

const ScrollMouse = (props) => (
    <Icon iconName="ScrollMouse" {...props}>
        <LottieAnimation animationData={animationData} />
    </Icon>
);

export default ScrollMouse;
